import React from 'react';
import ReactDOM from 'react-dom/client';
import './App.css';
import App from './App';
import TravelOffersView from './views/TravelOffersView';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Simple path-based routing without bringing in react-router:
// - "/"       → main chat/landing App
// - "/offers" → DBS Travel Card Offers viewer
const path = window.location.pathname || '/';

const renderElement =
  path === '/offers' ? (
    <React.StrictMode>
      <TravelOffersView />
    </React.StrictMode>
  ) : (
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );

root.render(renderElement);
